/** Origine d'une ligne de détail de plan de production (issue #3623) — miroir de OrigineLignePlanProductionEnum côté back. */
export enum OrigineLignePlanProductionEnum {
  MENU = 'MENU',
  GCOM = 'GCOM',
  PRODUIT_COMPLEMENTAIRE = 'PRODUIT_COMPLEMENTAIRE'
}

export const ORIGINE_LIGNE_PLAN_PRODUCTION_LABELS: Record<OrigineLignePlanProductionEnum, string> = {
  [OrigineLignePlanProductionEnum.MENU]:                   'Menu',
  [OrigineLignePlanProductionEnum.GCOM]:                   'Prise de commande',
  [OrigineLignePlanProductionEnum.PRODUIT_COMPLEMENTAIRE]: 'Produit complémentaire',
};
